import {createContext, useContext, useEffect, useState} from "react";

type Alert = {
  type: "success" | "error";
  message: string;
};

type AlertContextType = {
  alerts: Alert[];
  addAlert: (alert: Alert) => void;
};

export const WidgetContext = createContext<AlertContextType>(
  {} as AlertContextType,
);

export const useWidgetContext = () => useContext(WidgetContext);

export const WidgetProvider = ({children}: {children: React.ReactNode}) => {
  const [alerts, setAlerts] = useState<Alert[]>([]);
  const [startIdx, setStartIdx] = useState<number>();

  useEffect(() => {
    const timer = setTimeout(() => setStartIdx(undefined), 5000);
    return () => clearTimeout(timer);
  }, [alerts]);

  const addAlert = (alert: Alert) => {
    const newAlerts = [...alerts, alert];
    setAlerts(newAlerts);
    if (startIdx === undefined) {
      setStartIdx(newAlerts.length - 1);
    }
  };

  return (
    <WidgetContext.Provider
      value={{
        alerts: startIdx === undefined ? [] : alerts.slice(startIdx),
        addAlert,
      }}
    >
      {children}
    </WidgetContext.Provider>
  );
};
